<template>
  <div
    class="d-flex align-center justify-center"
    :style="{ height: 'calc(100% - 135px)' }"
  >
    <div
      class="d-flex flex-column align-center pa-10"
      :style="{ width: '100%', maxWidth: '700px' }"
    >
      <img
        src="img/propuesta-1-x2.svg"
        class="mb-4"
        :style="{ width: '40%' }"
        alt="Logotipo de IUSA En Línea"
      />
      <h2 class="font-weight-bold mb-10">TE DA LA BIENVENIDA</h2>
      <p class="text-body-2">
        ¿De qué canal te gustaría visualizar la información?
      </p>

      <div
        class="d-flex flex-column overflow-hidden rounded"
        :style="{ border: '1px solid #686868', width: '400px' }"
      >
        <label
          v-for="channel in availableChannels"
          :key="channel.value"
          class="flex-grow-1 pa-2 text-left"
          :style="{
            cursor: selectedChannel === channel.value ? 'default' : 'pointer',
            backgroundColor:
              selectedChannel === channel.value ? '#686868' : 'transparent',
            color: selectedChannel === channel.value ? '#fff' : '#686868',
            transition: 'background-color 0.2s, color 0.2s',
          }"
          @click="onSelectChannel(channel.value)"
        >
          {{ channel.label }}
        </label>
      </div>

      <v-btn
        color="#E20809"
        class="mt-8"
        dark
        :elevation="0"
        @click="onContinue"
      >
        Continuar
      </v-btn>
    </div>
  </div>
</template>

<script>
  import { Channels } from '@/core/constants/channelConstants';
  import { Roles } from '@/core/constants/roleConstants';
  import { mapGetters, mapActions } from 'vuex';

  const ROLE_ROUTE_MAP = [
    {
      roles: [Roles.EXPRESS_SALES, Roles.BRIEFCASE],
      route: 'ResultsExpressSales',
    },
    {
      roles: [Roles.REGIONAL_MANAGER],
      route: 'DailyRegionalManager',
    },
    {
      roles: [Roles.CREDIT_COLLECTIONS, Roles.CREDIT_ASSISTANT],
      route: 'CreditCustomersAdvance',
    },
    {
      roles: [Roles.SUB_DIRECTOR],
      route: 'DailySubDirector',
    },
    {
      roles: [Roles.PRESIDENCY],
      route: 'Visor',
    },
  ];

  export default {
    name: 'ChannelSelectionView',
    data: () => ({
      selectedChannel: null,
    }),
    computed: {
      ...mapGetters('auth', ['user']),
      availableChannels() {
        return Object.entries(this.user.channels ?? {}).map(([code, name]) => ({
          value: code,
          label: `${code} - ${name.toUpperCase()} `,
        }));
      },
    },
    created() {
      this.selectedChannel = Channels.RETAIL;
      this.$store.commit(
        'auth/SET_PREVIEW_NAVIGATION_CHANNEL',
        Channels.RETAIL
      );
    },
    methods: {
      ...mapActions('auth', ['actualizarUsuario']),
      async onSelectChannel(channel) {
        this.selectedChannel = channel;
        this.$store.commit('auth/SET_PREVIEW_NAVIGATION_CHANNEL', channel);
      },
      async onContinue() {
        this.$store.commit('auth/SET_PREVIEW_NAVIGATION_CHANNEL', null);

        localStorage.setItem('channel', this.selectedChannel);
        await this.actualizarUsuario(this.selectedChannel);

        const match = ROLE_ROUTE_MAP.find((r) => this.$hasAnyRole(r.roles));
        this.$router.push({ name: match?.route ?? 'Home' });
      },
    },
  };
</script>

<style scoped></style>
